/**
 * Gated `console` output. **Default: off.**
 *
 * Set `REACT_APP_DEBUG_LOG=true` (e.g. `_.env` / Docker, `.env.local` for `npm start`, or the
 * `react-app-debug-log` secret in Kubernetes). Other environments should keep the secret as `false`.
 */

export function isAppDebugLogEnabled(): boolean {
  return String(process.env.REACT_APP_DEBUG_LOG).toLowerCase() === 'true';
}

export function appDebugLog(...args: unknown[]): void {
  if (!isAppDebugLogEnabled()) return;
  // eslint-disable-next-line no-console -- intentional debug stream behind REACT_APP_DEBUG_LOG
  console.log(...args);
}

export function appDebugWarn(...args: unknown[]): void {
  if (!isAppDebugLogEnabled()) return;
  // eslint-disable-next-line no-console -- intentional debug stream behind REACT_APP_DEBUG_LOG
  console.warn(...args);
}
